import { CloseOutlined, EditOutlined, CheckOutlined } from '@ant-design/icons';

import { useEffect, useState } from 'react';

import { Button, Select, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

import Address from './Address';
import { getAddressFromEntityAddress, getMDMEntityClient } from '../../clientUtils';

const getAddressesOptions = (entities) =>
  entities
    ?.filter((address) => address?.is_shipping)
    ?.map((address) => ({
      label: getAddressFromEntityAddress(address),
      value: address?.id
    }));

const EditableAddress = ({ address, edit, buyer, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [entities, setEntities] = useState();
  const [selectedAddress, setSelectedAddress] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!buyer) return;

    const getEntities = async () => {
      const response = await getMDMEntityClient().entityIdGet(buyer);
      setEntities(response?.data?.data?.addresses);
    };
    getEntities();
  }, [buyer]);

  const handleSave = () => {
    const save = async () => {
      setLoading(true);
      const res = await onSave(selectedAddress.id);
      setLoading(false);
      setEditing(false);
      setSelectedAddress();
      if (res) navigate(0);
    };
    save();
  };

  if (editing) {
    return (
      <Space direction="vertical">
        <Select
          onChange={(id) => {
            const tempAddress = entities.filter((ta) => ta?.id === id);
            setSelectedAddress({ id, address: tempAddress[0] });
          }}
          options={getAddressesOptions(entities)}
          style={{ width: 200 }}
        />
        {selectedAddress ? <Address entity={selectedAddress?.address} /> : null}
        <Space>
          {selectedAddress ? (
            <Button className="action-btn" icon={<CheckOutlined />} loading={loading} onClick={handleSave} type="link">
              Save
            </Button>
          ) : null}
          <Button
            className="color-454C53"
            icon={<CloseOutlined />}
            onClick={() => {
              setSelectedAddress();
              setLoading(false);
              setEditing(false);
            }}
            size="small"
            type="link">
            Cancel
          </Button>
        </Space>
      </Space>
    );
  }

  return (
    <Space direction="vertical">
      <Address entity={address} />
      {edit ? (
        <Button className="action-btn" icon={<EditOutlined />} onClick={() => setEditing(true)} type="link">
          Edit
        </Button>
      ) : null}
    </Space>
  );
};

export default EditableAddress;
